<template>
  <div class="flex justify-center mx-auto">
    <el-dialog
      title="Enter Details"
      :visible.sync="showDialog"
      :width="modalWidth"
      top="30vh"
      :before-close="handleClose"
      append-to-body
    >
      <el-form
        class=""
        ref="formData"
        label-position="top"
        :model="formData"
        label-width="120px"
        :rules="rules"
      >
        <el-form-item label="Base Url" prop="url">
          <el-input
            v-model.trim="formData.url"
            :placeholder="baseUrlPlaceholder"
          ></el-input>
        </el-form-item>
        <div class="mt-6">
          <span slot="footer" class="dialog-footer">
            <el-button
              :loading="isLoading"
              class="w-full text-white rounded-md border-none py-4 bg-primary"
              @click="validateForm('formData')"
            >
              {{ isLoading ? 'Verifying' : 'Submit' }}
            </el-button>
          </span>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import { TEST_URl } from '@/utils/constants.js'
import { ValidateWebsiteUrl } from '@/utils/helpers.js'
export default {
  props: {
    showDialog: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isLoading: false,
      formData: {
        url: ''
      },
      rules: {
        url: [
          {
            required: true,
            message: 'Please input url',
            trigger: ['blur', 'change']
          },
          { validator: ValidateWebsiteUrl, trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  computed: {
    modalWidth () {
      return breakpoints.lgAndUp ? '30%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    baseUrlPlaceholder () {
      return process.env.VUE_APP_BASE_URL
    }
  },
  methods: {
    validateForm (formData) {
      this.$refs[formData].validate((valid) => {
        if (valid) {
          this.handleSubmitUrl()
        } else {
          this.$notify.error({
            title: 'Incomplete details',
            message: 'Please fill the missing information',
            position: 'top-right'
          })
        }
      })
    },
    handleClose () {
      this.$emit('closeDialog')
    },
    async handleValidateBaseUrl () {
      this.isLoading = true
      let payload
      const healthData = this.formData.url

      if (healthData.includes('/v1') || healthData.includes('/v2')) {
        const modifiedHealthData = healthData.replace(/\/v[1-2]/, '')
        payload = modifiedHealthData
      }
      await this.$store
        .dispatch('auth/getBaseUrl', payload)
        .then(() => {
          this.isLoading = false
          this.$store.dispatch('auth/setBaseUrl', this.formData.url)
          localStorage.setItem(TEST_URl, this.formData.url)
          this.handleClose()
          this.$message({
            showClose: true,
            message: 'Base Url updated successfully',
            type: 'success'
          })
          window.location.reload()
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    async handleSubmitUrl () {
      await this.handleValidateBaseUrl()
    }
  }
}
</script>

<style scoped>
>>> .el-dialog {
  border-radius: 12px;
  padding: 0px 20px 10px 10px;
}
>>> .el-dialog__body {
  padding: 0px 20px;
}
>>> .el-dialog__wrapper {
  overflow: hidden;
  top: 14px;
}
>>> .el-icon-close:before {
  padding: 25px;
  opacity: 0.9;
  color: #c1c4ca;
}
>>> .el-dialog__headerbtn :hover {
  color: #c1c4ca !important ;
}
>>> .el-input__inner {
  border-radius: 8px;
  padding-right: 3px;
  line-height: 20px;
  font-weight: 400;
  border-color: #c7c8d2;
  height: 48px;
}
</style>
